export const ADDRESSBOOKS_RESET_STATE = 'ADDRESSBOOKS_RESET_STATE';
export const ADDRESSBOOKS_CURRENT_ITEM = 'ADDRESSBOOKS_CURRENT_ITEM';

export const ADDRESSBOOKS_REQUEST_LOADING = 'ADDRESSBOOKS_REQUEST_LOADING';
export const ADDRESSBOOKS_REQUEST_SUCCESS = 'ADDRESSBOOKS_REQUEST_SUCCESS';
export const ADDRESSBOOKS_REQUEST_FAILED = 'ADDRESSBOOKS_REQUEST_FAILED';

export const ADDRESSBOOKS_CURRENT_ACTION = 'ADDRESSBOOKS_CURRENT_ACTION';
export const ADDRESSBOOKS_RESET_ACTION = 'ADDRESSBOOKS_RESET_ACTION';